<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hZAGWj/CoverDesign.jpg?1685327251754" alt="This image is the cover for the book Shifting Views, The Carlisles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shifting Views, The Carlisles
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>A Carlisles novel</i></b></p><p>Successful fashion model Denver Carlisle is finally living on his own. He’s got a new apartment, a neighbor who has a problem shutting his blinds, and a local bakery with an owner who makes his knees weak. It’s raining men, and Denver hasn’t gotten any in a long time. Going out on a limb, he asks Ethan Monahan out and resorts to a little exhibitionism for his neighbor. Only to be turned down by both. That’s a first. </p> <p>Ethan Monahan runs his own bakery and has a new neighbor who walks around naked. The latter is a little too distracting. When his naked neighbor turns out to be none other than model Denver Carlisle—and the customer who asked him out—Ethan tries to make amends. In a purely friendly way. </p> <p>Friendship leads to more, and both men find themselves in over their heads with emotions and compromises. Denver has trust issues that could span the Sahara, and Ethan is a product of the foster system with a chip on his shoulder and a serious wariness of those with money. There’s only one way to reconcile their issues: work together.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Meg Harding
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dad57eda